import axios from "axios";
import { LOTE_SELECTED_ID, LOTE_GET, LOTE_PHOTO_GET, UNIDADE_LIST, UNIDADE_INNER_LIST, CONFIG_ESTATISTICA_GET } from "./Events";
import { toDoWithForms, notifyApiError } from "./utils";

export function clear() {
  return function (dispatch) {
    dispatch({ type: LOTE_GET, payload: null });
    dispatch({ type: LOTE_SELECTED_ID, payload: null });
    dispatch({ type: LOTE_PHOTO_GET, payload: null });
  };
}

export function clearList() {
  return function (dispatch) {
    dispatch({ type: UNIDADE_LIST, payload: null });
  };
}

export function get(id, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/Get/${id}`);

    dispatch({ type: LOTE_SELECTED_ID, payload: id });

    request
      .then(response => {
        dispatch({ type: LOTE_GET, payload: response.data });

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}


export function getConfigEstatisticasIptu(successCallback) {
  return function (dispatch) {

    const request = axios.get(`/PublicConfig/GetEstatisticaColors/`);

    request
      .then(response => {

        const data = {};
        data.colors = JSON.parse(response.data.colors);
        dispatch({ type: CONFIG_ESTATISTICA_GET, payload: data });

        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {

      });
  };
}

export function getEstatisticasIptuBairro(id, successCallback) {
  return function (dispatch) {

     const request = axios.get(`/PublicLote/GetEstatisticasIptuBairro/${id}`);

    request
      .then(response => {
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {

      });
  };
}

export function exportXlsx(filter) {
  return function (dispatch) {
    filter.groupKey = '[LIST]';

    toDoWithForms( `/PublicLote/ExportXlsx`, filter );
  }
}


export function getUnidade(unidadeId, groupKey, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetUnidade?id=${unidadeId}&groupKey=${groupKey}`);

    request
      .then(response => {

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}

export function getUnidadeImpostosIptu(unidadeId, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetTributosUnidadeIptu/${unidadeId}`);
    request
      .then(response => {

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}


export function getUnidadeImpostosItbi(unidadeId, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetTributosUnidadeItbi/${unidadeId}`);
    request
      .then(response => {

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}

export function getUnidadeImpostosIptuDetalhado(unidadeId, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetTributosUnidadeIptuDetalhado/${unidadeId}`);
    request
      .then(response => {
        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}

export function getRelatorioUnidade(unidadeId, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetRelatorioUnidade/${unidadeId}`);
    request
      .then(response => {

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}
export function getRelatorioUnidadeRedeSim(inscricao, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetRelatorioUnidadeRedeSim?inscricao=${inscricao}`);
    request
      .then(response => {

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}

export function getAvaliacoes(unidadeId, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetAvaliacoes/${unidadeId}`);

    request
      .then(response => {
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}



export function getPhotos(id, successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetPhotos/${id}`);

    request
      .then(response => {
        dispatch({ type: LOTE_PHOTO_GET, payload: response.data });

        if (successCallback) {
          successCallback(response);
        }

      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });

  };
}


//#region LIST
export function list(filter, successCallback) {
  return function (dispatch) {
    filter.groupKey = '[LIST]';
    const request = axios.post(`/PublicLote/ListUnidade`, filter);
    request
      .then(response => {
        dispatch({ type: UNIDADE_LIST, payload: response.data });
        
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch((error) => {
        notifyApiError(error, 'Não foi possível concluir a busca');
      });
  };
}
export function innerList(filter, successCallback) {
  return function (dispatch) {
    filter.groupKey = '[INNER_LIST]';
    const request = axios.post(`/PublicLote/ListUnidade`, filter);
    request
      .then(response => {
        dispatch({ type: UNIDADE_INNER_LIST, payload: response.data });
        
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch((error) => {
        notifyApiError(error, 'Não foi possível listar as unidades do lote');
      });
  };
}

export function identifyOnExtent(geographicExtent, successCallback) {
  return function (dispatch) {
    const request = axios.post(`/PublicLote/IdentifyOnExtent`, geographicExtent);

    request
      .then(response => {
        //dispatch({ type: IMOVEL_LIST, payload: response.data });
        
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {

      });
  };
}


export function getPlaceHolderByModule(successCallback, errorCallback) {
  return function (dispatch) {
    const request = axios.get(`/PublicLote/GetPlaceHolderByModule`);

    request
      .then(response => {
        if (successCallback) {
          successCallback(response);
        }
      })
      .catch(() => {
        if (errorCallback)
          errorCallback();
      });
  };
}

//#endregion